import { useState, useEffect, useRef } from 'react';

export const useMobileNavigation = () => {
  const [opensmdrop, setOpensmdrop] = useState(false);
  const [opensmsearch, setOpensmsearch] = useState(false);
  const [show, setShow] = useState(false); // Enterprise modal
  const dropdownRef = useRef(null);

  const toggledrop = (e) => {
    e.stopPropagation();
    setOpensmdrop((prevState) => !prevState);
    setOpensmsearch(false);
  };

  const toggledropsearch = (e) => {
    e.stopPropagation();
    setOpensmsearch((prevState) => !prevState);
    setOpensmdrop(false);
  };

  const handleClosedrop = () => {
    setOpensmdrop(false);
    setOpensmsearch(false);
  };

  const handleShow = () => {
    setShow(true);
    setOpensmdrop(false);
    setOpensmsearch(false);
  };

  const handleClose = () => {
    setShow(false);
    setOpensmsearch(false);
  };

  const handleOutsideDropdown = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpensmdrop(false);
      setOpensmsearch(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideDropdown);
    return () => {
      document.removeEventListener('mousedown', handleOutsideDropdown);
    };
  }, []);

  return {
    opensmdrop,
    opensmsearch,
    show,
    dropdownRef,
    toggledrop,
    toggledropsearch,
    handleClosedrop,
    handleShow,
    handleClose,
  };
}; 